import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch branches for a specific restaurant
 * @param {number} restaurantId - The ID of the restaurant
 * @param {string} language - Language for the response (default: 'en')
 * @returns {Promise<Object>} - Response data from the API containing restaurant branches
 */
export const getRestaurantBranches = async (restaurantId, language = 'en') => {
  try {
    const endpoint = API_ENDPOINTS.RESTAURANT_BRANCHES.replace(':restaurantId', restaurantId);
    const response = await apiClient.get(`${endpoint}?language=${language}`);
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
